import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { Select } from '@occc-app/design-system';
import { Publication_Status_Type } from '@occc/graphql';

import { CampaignsFilterFormValues, CampaignStatusFilter } from '../types';

export type CampaignsFilterFormProps = {
  onSubmit: FormProps<CampaignsFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: Partial<CampaignsFilterFormValues>;
  showOfferFilters?: boolean;
};

const statusSelectData = [
  { label: 'All', value: CampaignStatusFilter.All },
  { label: 'Active', value: CampaignStatusFilter.Active },
  { label: 'Archived', value: CampaignStatusFilter.Archived },
];

const publicationStatusSelectData = [
  { label: 'All', value: Publication_Status_Type.All },
  { label: 'Published', value: Publication_Status_Type.Published },
  { label: 'Unpublished', value: Publication_Status_Type.Unpublished },
  { label: 'Expired', value: Publication_Status_Type.Expired },
];

export const CampaignsFilterForm: React.FC<CampaignsFilterFormProps> = ({
  onSubmit,
  onReset,
  initialValues,
  showOfferFilters,
}) => {
  const renderForm: FormRenderProps<CampaignsFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form }: FormRenderProps<CampaignsFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <Box px={4} pt={4}>
            <Box mb={2}>
              <Typography paragraph>Campaign Status</Typography>
              <Select name='status' label='Campaign Status' data={statusSelectData} />
            </Box>
            {showOfferFilters && (
              <Box mb={2}>
                <Typography paragraph>Offer Publication Status</Typography>
                <Select
                  name='publicationStatus'
                  label='Offer Publication Status'
                  data={publicationStatusSelectData}
                />
              </Box>
            )}
          </Box>
          <Box display='flex' justifyContent='flex-end' px={3} py={2}>
            <Button size='small' color='error' onClick={reset}>
              reset
            </Button>
            <Button type='submit' size='small' color='primary'>
              apply
            </Button>
          </Box>
        </form>
      );
    },
    [showOfferFilters, onReset],
  );
  return (
    <Form<CampaignsFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
